/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useContext } from 'react';
import { faPencilAlt, faTimes, faSave } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppContext } from '@ctsu/loader';
import {
  CanUserCopyPacket,
  CanUserCommunicate,
  CanUserEditDetails,
  CanUserSeeSupportingDocs
} from 'appconstants/Permission';
import { ATCONSTANTS as ATC } from 'appconstants';

function DetailsHeader({
  isEditing,
  toggleEdit,
  onSave,
  supportingClick,
  onClickCopy,
  communicatePacket,
  status,
  packet,
  controller,
  appliedFilters,
  editedDetails,
  cancelModel,
  closeComModal,
  saveHandler
}) {
  const context = useContext(AppContext);
  const { session } = context;
  return (
    <div className="form-layout-header">
      <div className="form-layout-toolbar" style={{ marginTop: '-.5rem' }}>
        {!isEditing && (
          <span>
            {CanUserCopyPacket() && (
              <button
                data-id={`${ATC.PACKETID}ADDITIONAL_COPY${ATC.BUTTON}`}
                className="btn turquoise mr-1 px-2"
                type="button"
                title="Create copy of currently selected row above"
                disabled={packet.lockedBy !== session.username}
                onClick={onClickCopy}
              >
                Copy
              </button>
            )}
            {CanUserCommunicate() && (
              <button
                onClick={() => {
                  const extraProps = {
                    controller, editedDetails, packetId: packet.packetId, appliedFilters, saveHandler, closeComModal, cancelModel
                  };
                  communicatePacket(false, status, extraProps);
                }}
                data-id={`${ATC.PACKETID}COMMUNICATE_EMAIL${ATC.BUTTON}`}
                className="btn turquoise mr-1 px-2"
                type="button"
                disabled={packet.lockedBy !== session.username}
                title="Communicate"
              >
                Communicate
              </button>
            )}
            {CanUserSeeSupportingDocs() && (
              <button
                onClick={supportingClick}
                className="btn turquoise mr-1 px-2"
                type="button"
                title="Supporting Docs"
                data-id={`${ATC.PACKETID}SUPPORTING_DOCS${ATC.BUTTON}`}
              >
                Supporting Docs
              </button>
            )}
          </span>
        )}
        {isEditing ? (
          <button
            type="button"
            data-id={`${ATC.PACKETID}ADDITIONAL_SAVE${ATC.BUTTON}`}
            onClick={onSave}
            className="fn-btn mx-1"
            title="Save"
          >
            <FontAwesomeIcon icon={faSave} />
          </button>
        ) : null}
        {packet.lockedBy === session.username && CanUserEditDetails() ? (
          <button
            data-id={`${ATC.PACKETID}ADDITIONAL_EDIT${ATC.BUTTON}`}
            type="button"
            onClick={toggleEdit}
            className={`fn-btn ${isEditing ? 'close' : 'edit'}`}
            title={isEditing ? 'Close' : 'Edit'}
          >
            {isEditing ? <FontAwesomeIcon icon={faTimes} /> : <FontAwesomeIcon icon={faPencilAlt} />}
          </button>
        ) : null}
      </div>
      <div className="form-layout-title" role="heading" aria-level="3">
        Additional Details
      </div>
    </div>
  );
}
export default DetailsHeader;
